import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getProductSettings } from '@/api'
import type {
  ISettings,
  IFilter,
  IPlacementData,
} from '@/types'
import { getAccountId, getPlacementId } from '@/utils'

export const useSettingsStore = defineStore('settings', () => {
  const loading = ref(false)
  const error = ref<Error | null>(null)
  const initialized = ref(false)

  const accountId = getAccountId()
  const placementId = getPlacementId()

  const sortType = ref('desc')
  const imageType = ref('front34')
  const filter = ref<IFilter[]>([])
  const baseUrl = ref('')
  const showVehicleCount = ref(false)
  const vehicleNameType = ref('')
  const viewMode = ref('')
  const usedDrag = ref(false)
  const itemSetting = ref({
    verticalGap: '20px',
  })

  const imageSetting = ref({
    width: '100%',
    height: 'auto',
  })
  const labelSetting = ref({
    color: '#000000',
    hoverColor: '#FF0000',
    typography: {
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '1.5em',
    },
  })
  const callToActionSetting = ref({
    label: 'View Details',
    link: '/vehicle/{{vin}}',
    color: '#000',
    typography: {
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '1.5em',
    },
    arrow: {
      backgroundColor: '#000000',
      color: '#FF0000',
      containerSize: '30px',
      iconSize: '30px',
    },
  })
  const sliderSetting = ref({
    arrow: {
      color: '#000000',
      backgroundColor: '#FFFFFF',
      size: '30px',
    },
  })

  const updateSettings = (newSettings: ISettings | null) => {
    if (newSettings == null) {
      console.error('Invalid settings provided.')
      return
    }

    console.log(newSettings, 'newSettings')
    if (newSettings.theme) {
      if (newSettings.theme === 'dark') {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.add('light')
      }
    }

    if (newSettings.filter) {
      console.log(newSettings.filter)
      filter.value = newSettings.filter as unknown as IFilter[]
    }

    if (newSettings.usedDrag) {
      usedDrag.value = newSettings.usedDrag
    }
    if (newSettings.viewMode) {
      viewMode.value = newSettings.viewMode
    }

    if (newSettings.baseUrl) {
      baseUrl.value = newSettings.baseUrl
    }
    if (newSettings.showVehicleCount) {
      showVehicleCount.value = newSettings.showVehicleCount
    }
    if (newSettings.vehicleNameType) {
      vehicleNameType.value = newSettings.vehicleNameType
    }

    if (newSettings.sort) {
      sortType.value = newSettings.sort
    }

    if (newSettings.imageType) {
      imageType.value = newSettings.imageType
    }

    if (newSettings.item) {
      itemSetting.value = newSettings.item
    }

    if (newSettings.image) {
      imageSetting.value = newSettings.image
    }

    if (newSettings.label) {
      labelSetting.value = newSettings.label
    }

    if (newSettings.callToAction) {
      callToActionSetting.value = newSettings.callToAction
    }

    if (newSettings.slider) {
      sliderSetting.value = newSettings.slider
    }
  }

  const validateSettings = (settings: ISettings): boolean => {
    return !(
      !settings.hasOwnProperty('theme') ||
      !settings.hasOwnProperty('sort') ||
      !settings.hasOwnProperty('imageType') ||
      !settings.hasOwnProperty('viewMode') ||
      !settings.hasOwnProperty('item') ||
      !settings.hasOwnProperty('image') ||
      !settings.hasOwnProperty('label') ||
      !settings.hasOwnProperty('callToAction') ||
      !settings.hasOwnProperty('slider')
    )
  }

  const resetError = () => {
    error.value = null
  }

  const fetchSettings = async () => {
    // Don't fetch if already initialized
    if (initialized.value) {
      return
    }

    loading.value = true
    error.value = null

    try {
      const productId = 'jellybeans'

      const data: IPlacementData | null = await getProductSettings(
        accountId,
        productId,
      )

      if (placementId.length > 0 && placementId !== 'default') {
      }
      if (data == null) {
        error.value = new Error('Failed to fetch settings')
        return
      }

      console.log(data, 'ssetings')
      updateSettings(data?.placements[placementId] || null)
      initialized.value = true
    } catch (err) {
      error.value =
        err instanceof Error ? err : new Error('Unknown error occurred')
      throw error.value
    } finally {
      loading.value = false
    }
  }

  return {
    // State
    accountId,
    placementId,
    imageType,
    itemSetting,
    imageSetting,
    labelSetting,
    callToActionSetting,
    sliderSetting,
    loading,
    error,
    initialized,
    sortType,
    filter,
    baseUrl,
    showVehicleCount,
    vehicleNameType,
    viewMode,
    usedDrag,

    fetchSettings,
    resetError,
  }
})
